// extracted by mini-css-extract-plugin
module.exports = {"root":"PieChart_root__1yN6Y"};